export enum NotesLevelType {
	L1 = "L1",
	L2 = "L2",
	L3 = "L3",
}

export enum NotesLevelMappingType {
	L1 = "listening_priority",
	L2 = "topics",
	L3 = "sub_topics",
}

export enum NotesChildMappingType {
	L1 = NotesLevelType.L2,
	L2 = NotesLevelType.L3,
}

export enum NotesParentMappingType {
	L2 = NotesLevelType.L1,
	L3 = NotesLevelType.L2,
}

export enum DateRangeSlicerType {
	"3M" = "3",
	"6M" = "6",
	"1Yr" = "12",
	"2Yr" = "24",
	"Max" = "max",
}
export enum CachedSummaryPollerStatusType {
	InProgress = "in_progress",
	Success = "success",
	Error = "error",
}

export interface INotesLeftPanelData {
	name?: string;
	level_name?: string;
	level: NotesLevelType;
	current_count: number;
	previous_count: number;
	delta: number;
	is_artificial?: boolean;
	parent?: string[];
	parent_l1?: string | null;
	parent_l2?: string | null;
	children?: INotesLeftPanelData[];
	longitudinal_data?: {
		x_axis: string;
		y_axis: number;
	}[];
}

export interface ILeftPaneItemProps {
	item: INotesLeftPanelData;
	parent: INotesLeftPanelData;
	handleLevelSelect: (item: INotesLeftPanelData, parent: INotesLeftPanelData) => void;
	currentLevel: number;
}

export interface IChildItemProps {
	item: INotesLeftPanelData;
	name: string;
	count?: number;
	currentCount: number;
	previousCount: number;
	delta: number;
	isSelected: boolean;
	parent: INotesLeftPanelData;
	isArtificial: boolean;
	onClick: () => void;
}

export interface IHighlightedTextProps {
	text: string;
	highlight: string;
}
export interface INotesFilterDrawerChildItemProps {
	item: any;
	isSelected: boolean;
	onChange: (itemValue: any, checked: any) => void;
	searchText: string;
}
export interface IGroupItemProps {
	group: any;
	isFullySelected: boolean;
	isPartiallySelected: boolean;
	onGroupChange: (groupData: any, checked: boolean) => void;
	onToggleCollapse: (groupKey: any) => void;
	isExpanded: boolean;
	searchText: string;
}
export interface INotesLongitudinalChartProps {
	error?: boolean;
}

export interface ILeftPanelPopoverContent {
	item: INotesLeftPanelData;
	parent?: string[];
	isChildItem: boolean;
	isTruncated?: boolean;
}

export interface IUnmappedData {
	total: number | null;
	noDate: number | null;
	noLabel: number | null;
}

export interface IDataPoints {
	total: number;
	filtered: number;
	missingDates: number;
}

export interface IAllDateRanges {
	"3M": IDateRange;
	"6M": IDateRange;
	"1Yr": IDateRange;
	"2Yr": IDateRange;
	Max: IDateRange;
}

export interface IDateRange {
	start: string | Date | null;
	end: string | Date | null;
	disabled?: boolean;
	is_date_available?: boolean;
}

export interface IFilterData {
	title: string;
	value: string;
	key: string;
	children?: {
		title: string;
		value: string;
		key: string;
	};
}

export interface INotesReferenceData {
	_id: string;
	fact_os_notes_id: string;
	notes_text: string;
	date: string;
	tags?: {
		tag_category: string;
		tag_value: string;
	}[];
}

export interface ILongitudinalChartData {
	x_axis: string;
	y_axis: number;
}
